import type * as React from "react";
import { cn } from "#/lib/utils";

export function FilterChip({
	active,
	className,
	...props
}: React.ComponentProps<"button"> & {
	active: boolean;
}) {
	return (
		<button
			type="button"
			className={cn(
				"cursor-pointer rounded-full px-3 py-1 text-label1-medium transition-colors",
				active
					? "bg-primary/10 text-primary"
					: "text-muted-foreground hover:bg-muted/50 hover:text-foreground",
				className,
			)}
			{...props}
		/>
	);
}
